import { Form } from "antd";
import { filterAtom } from "components/UI/BaseFilter/atoms/filterAtom.ts";
import { saveFiltersToLocalStorage } from "components/UI/BaseFilter/atoms/filterAtom.ts";
import { BaseFilter } from "components/UI/BaseFilter/BaseFilter.tsx";
import { usePaldockTranslation } from "hooks/usePaldockTranslation";
import { toast } from "react-toastify";
import { useRecoilValue } from "recoil";
import { FormId } from "types/models.ts";

import OfferData = App.Data.OfferData;

interface OfferFilterEditFormProps {
    offer: OfferData;
}

export const OfferFilterEditForm = ({ offer }: OfferFilterEditFormProps) => {
    const [form] = Form.useForm();
    const filterState = useRecoilValue(filterAtom);
    const formId = FormId.OfferFilterEditForm;
    const { t } = usePaldockTranslation("ui.offer-filter");

    const handleSubmit = async () => {
        // Save the current filter state to localStorage on form submit
        saveFiltersToLocalStorage(filterState);
        toast.success(t("messages.filters_saved"));

        return Promise.resolve();
    };

    return (
        <Form form={form} id={formId} onFinish={handleSubmit} layout="vertical">
            <BaseFilter offer={offer} />
        </Form>
    );
};
